module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-hocker-04.6accee37.jpeg";